export const CheckoutKeys = {
  base: 'checkout',
  bySessionId: (sessionId: string): string[] =>
    [CheckoutKeys.base, sessionId].filter(Boolean) as string[],
  productConfig: (productType: string): string[] => [CheckoutKeys.base, 'config', productType].filter(Boolean) as string[]
};
